import EventEmitter from 'eventemitter3';

const eventEmitter = new EventEmitter();

export type EventTypes = string;

export type EventContext = any;

export function formatEventName(app: string, event: string) {
  return `${app}/${event}`;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 */
export function eventNames() {
  return eventEmitter.eventNames();
}

/**
 * Return the listeners registered for a given event.
 */
export function listeners(app: string, event: string) {
  return eventEmitter.listeners(formatEventName(app, event));
}

/**
 * Return the number of listeners listening to a given event.
 */
export function listenerCount(app: string, event: string) {
  return eventEmitter.listenerCount(formatEventName(app, event));
}

/**
 * Calls each of the listeners registered for a given event.
 */
export function emit(app: string, event: string, ...args: EventEmitter.EventArgs<EventTypes, string>) {
  return eventEmitter.emit(formatEventName(app, event), ...args);
}

/**
 * Add a listener for a given event.
 */
export function addListener(app: string, event: string, fn: EventEmitter.EventListener<EventTypes, string>, context?: EventContext) {
  return eventEmitter.addListener(formatEventName(app, event), fn, context);
}

export function on(app: string, event: string, fn: EventEmitter.EventListener<EventTypes, string>, context?: EventContext) {
  return eventEmitter.on(formatEventName(app, event), fn, context);
}

/**
 * Add a one-time listener for a given event.
 */
export function once(app: string, event: string, fn: EventEmitter.EventListener<EventTypes, string>, context?: EventContext) {
  return eventEmitter.once(formatEventName(app, event), fn, context);
}

/**
 * Remove the listeners of a given event.
 */
export function removeListener(app: string, event: string, fn: EventEmitter.EventListener<EventTypes, string>, context?: EventContext, once?: boolean) {
  return eventEmitter.removeListener(formatEventName(app, event), fn, context, once);
}

export function off(app: string, event: string, fn: EventEmitter.EventListener<EventTypes, string>, context?: EventContext, once?: boolean) {
  return eventEmitter.off(formatEventName(app, event), fn, context, once);
}

/**
 * Remove all listeners, or those of the specified event.
 */
export function removeAllListeners(app?: string, event?: string) {
  return eventEmitter.removeAllListeners(app && event ? formatEventName(app, event) : undefined);
}
